
// This is the config for the API base URL
const config = {
    development: {
        apiBaseUrl: "http://localhost:8000",
    },
    production: {
        apiBaseUrl: "https://tfg-cgcdaga0h6ekhrd6.eastus2-01.azurewebsites.net",
    },
    recaptcha: {
        sitekey: "6LfRxlorAAAAAGfuBX1Q_gMiqbTMYs8sxkdNSYZm",
    }
}

export default config